var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Select = dynamicRequire('Select.jsx');
var DimensionChooser = require('./DimensionChooser.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');

class DoubledoorRackChooser extends React.Component {

    render() {
        return <div>
            {this.getHeightUnitChooser()}
            {this.getChooser('depth')}
        </div>
    }

    getHeightUnitChooser() {
        return <div className="lr-casefactory-choices-sliders-dimensions-dimension-select dimension-select">
            <label><Mssg __key="nc_casefactory.height" /></label>
            <Select
                className="lr-style"
                options={this.getHeightUnitOptions()}
                    active={this.props.case.dimensions.interior.height/45}
                    choiceHandler={(value) => {
                        this.context.emitter.emit('dimensionChange', 'height_unit', value, true)
                    }}
            />
        </div>
    }

    getHeightUnitOptions() {
        return this.props.dimensions.height.map((height) => {
            return {
                value: height.unit,
                name: height.unit+' '+resolveLanguage('nc_casefactory.height.units')
            }
        })
    }

    getChooser(dimension) {
        var props = {
            start: this.props.case.dimensions.interior[dimension],
            range: {
                min: this.props.dimensions[dimension].min,
                max: this.props.dimensions[dimension].max,
            },
        }
        return <DimensionChooser dimension={dimension} {...props} label={'nc_casefactory.'+dimension} isCmMode={this.props.isCmMode}/>
    }
}


DoubledoorRackChooser.contextTypes = {
    emitter: React.PropTypes.object.isRequired,

};


module.exports = DoubledoorRackChooser;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/DoubledoorRackChooser.jsx